import React from 'react';
import { ui } from '../../../config/uiSizes';

export interface ImageHoverPreviewProps {
  show: boolean;
  position: { x: number; y: number };
  src: string;
}

export const ImageHoverPreview: React.FC<ImageHoverPreviewProps> = ({ show, position, src }) => {
  if (!show) return null;

  // Get responsive width based on viewport using the same breakpoints as ui.widthAndHeight.hoverPreview
  const getPreviewWidth = () => {
    const vw = window.innerWidth;
    if (vw >= 1536) return 1000; // 2xl
    if (vw >= 1280) return 850;  // xl
    if (vw >= 1024) return 850;  // lg
    if (vw >= 768) return 700;   // md
    return 600; // sm fallback
  };

  const previewWidth = getPreviewWidth();
  const modalWidth = Math.min(480, window.innerWidth * 0.38);
  const spaceToRight = window.innerWidth - position.x - modalWidth - 20;

  // Calculate horizontal position - position to the left of modal if not enough space to the right
  let leftPos = position.x + 150;
  if (spaceToRight < previewWidth) {
    leftPos = Math.max(10, window.innerWidth - modalWidth - previewWidth - 30);
  }

  const topPos = Math.max(10, position.y - 200);

  // Calculate panel width (matches the modal panel)
  const panelWidth = Math.min(480, window.innerWidth * 0.38);

  return (
    <>
      {/* Backdrop - only covers the left side, not the modal panel */}
      <div
        className="fixed top-0 left-0 bottom-0 z-[45] bg-black/25 backdrop-blur-sm pointer-events-none"
        style={{ right: `${panelWidth}px` }}
      />

      {/* Image Preview */}
      <div
        className={`fixed z-[50] pointer-events-none bg-white dark:bg-gray-900 rounded-lg shadow-2xl border border-gray-300 dark:border-gray-600 ${ui.widthAndHeight.hoverPreview}`}
        style={{
          left: `${leftPos}px`,
          top: `${topPos}px`,
          maxWidth: '90vw',
          maxHeight: '80vh'
        }}
      >
        <img
          src={src}
          alt="Campaign Management screenshot preview"
          className="w-full h-auto rounded-lg object-cover"
        />
      </div>
    </>
  );
};
